export default "__VITE_ASSET__DB24QkXH__"